
export enum UserType {
    USER = "USER",
    ADMIN = "ADMIN"
}